import { Action, Alias, Group } from "../../system/roles/constants";

export const MALICIOUS_IP_LIST_URL = ":config/:brandId?/malicious_ips";
export const MALICIOUS_BY_IP_URL =
  ":config/:brandId?/malicious_ips/:malicious_ip";
export const MALICIOUS_IP_LIST_RELEASE_URL =
  ":config/:brandId?/malicious_ips/:malicious_ip/release";

export type maliciousHistoryDataType = {
  id: number;
  malicious_ip_id: number;
  block_reason: string;
  blocked_at: string;
  blocked_until: string;
  unblock_reason: string;
  created_at: string;
  updated_at: string;
};

export type maliciousPropsType = {
  id: number;
  brand_id: number;
  ip: string;
  block_reason: string;
  blocked_at: string;
  blocked_until: string;
  block_count: number;
  created_at: string;
  updated_at: string;
};

export type malicioiusItemPropsType = maliciousPropsType & {
  history: maliciousHistoryDataType[];
};

export type maliciousDataType = {
  total: number;
  count: number;
  per_page: number;
  current_page: number;
  total_pages: number;
  data: maliciousPropsType[];
};

export const maliciousIpsAccess = {
  index: {
    group: [Group.MaliciousIPs],
    alias: [Alias.MaliciousIp],
    action: [Action.index],
  },
  show: {
    group: [Group.MaliciousIPs],
    alias: [Alias.MaliciousIp],
    action: [Action.show],
  },
  release: {
    group: [Group.MaliciousIPs],
    alias: [Alias.MaliciousIp],
    action: [Action.release],
  },
};

export const MALICIOUS_IP_LIST = "malicious_ip_list";
export const MALICIOUS_IP = "malicious_ip";
